import {
    addDays,
    addWeeks,
    format,
    isToday,
    isTomorrow,
    parse,
    startOfWeek
} from 'date-fns';
import { TFunction } from 'react-i18next';

import {
    DayWiseSlotHoldDatesDetailInterface,
    DDMMYYYY_DATE_FORMAT,
    WEBINAR_SLOTS_DATE_DISPLAY_FORMAT,
    WEEK_DAYS_COUNT
} from '@nw/shared/config';

import { TODAY, TOMORROW } from '../../constants/TimeLapsedConstants';

export const getTodayDate = (): Date => {
    return new Date();
};

export const getLabelText = (date: Date): string => {
    switch (true) {
        case isToday(date):
            return TODAY;
        case isTomorrow(date):
            return TOMORROW;
        default:
            return format(date, WEBINAR_SLOTS_DATE_DISPLAY_FORMAT);
    }
};

export const formatDatesStringToNewDateFormat = (
    datesArray: string[] | DayWiseSlotHoldDatesDetailInterface[],
    dateFormat: string = DDMMYYYY_DATE_FORMAT
) => {
    const formattedDatesArray: string[] = [];
    datesArray.forEach((eachDate) => {
        const date = eachDate.date ?? eachDate;

        const dateToFormat = parse(date, dateFormat, new Date());
        formattedDatesArray.push(String(dateToFormat));
    });
    return formattedDatesArray;
};

export const getDateFromDayCode = (dayCode: number) => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    let dayDifference = dayCode - currentDay;
    if (dayCode === WEEK_DAYS_COUNT.SUNDAY && currentDay !== 0) {
        dayDifference = (dayCode + 7 - currentDay) % 7;
    }
    currentDate.setDate(currentDate.getDate() + dayDifference);
    currentDate.setHours(0, 0, 0, 0);
    return currentDate;
};

export const getDayNameByDayCount = (dayCode: number, t: TFunction) => {
    switch (dayCode) {
        case WEEK_DAYS_COUNT.MONDAY:
            return "Monday";
        case WEEK_DAYS_COUNT.TUESDAY:
            return "Tuesday";
        case WEEK_DAYS_COUNT.WEDNESDAY:
            return "Wednesday";
        case WEEK_DAYS_COUNT.THURSDAY:
            return "Thursday";
        case WEEK_DAYS_COUNT.FRIDAY:
            return "Friday";
        case WEEK_DAYS_COUNT.SATURDAY:
            return "Saturday";
        default:
            return "Sunday";
    }
};

export const getNextDatesForDayCodes = (dayCodes: number[]) => {
    const currentDate = new Date();
    const currentDateWeekDay = currentDate.getDay();
    const nextDates: string[] = [];
    dayCodes.forEach((dayCode) => {
        let startOfNextWeek;
        if (currentDateWeekDay === 0 && dayCode !== 0) {
            startOfNextWeek = startOfWeek(currentDate);
        } else {
            startOfNextWeek = startOfWeek(addWeeks(currentDate, 1));
        }
        let targetDate = addDays(startOfNextWeek, dayCode);
        if (targetDate < currentDate) {
            targetDate = addWeeks(targetDate, 1);
        }
        nextDates.push(format(targetDate, DDMMYYYY_DATE_FORMAT));
    });

    return nextDates;
};

export const getNextNDates = (n = 10): Date[] => {
    const nextDates: Date[] = [];

    for (let i = 0; i < n; i++) {
        const nextDate = new Date(new Date().setDate(new Date().getDate() + i));
        nextDate.setHours(0, 0, 0, 0);
        nextDates.push(nextDate);
    }
    return nextDates;
};

